// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261104T091233112Z",
  "builtAt": "2026-11-04T09:12:33.112Z"
} as const;
